import './WizardTypeStep.scss';

export { default } from './WizardTypeStep';
